import { CircleUser, House, Library, Plus, Search, Users } from "lucide-react";
import * as React from "react";
import { useRef, useState } from "react";
import { NavLink } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import NavCord from "./NavCord";
import QuickLog from "./QuickLog";

/**
 * Mobile bottom navigation (ADR 0005). Hidden on desktop via CSS — the
 * header nav covers those widths. The center "Log" action opens the
 * QuickLog sheet rather than navigating. Signed in, a cord runs along its
 * top with a knot over the tab you're on, as the header's does.
 */
const BottomNav: React.FC = () => {
  const { user } = useAuth();
  const [logOpen, setLogOpen] = useState(false);
  const tabs = useRef<HTMLElement>(null);

  return (
    <>
      <nav
        className={user ? "bottom-nav bottom-nav-app" : "bottom-nav"}
        aria-label="Primary"
        ref={tabs}
      >
        <NavLink to="/" end>
          <span className="bottom-nav-icon" aria-hidden="true">
            <House size="1em" aria-hidden="true" />
          </span>
          Home
        </NavLink>
        <NavLink to="/browse">
          <span className="bottom-nav-icon" aria-hidden="true">
            <Search size="1em" aria-hidden="true" />
          </span>
          Browse
        </NavLink>
        {user ? (
          <>
            <button className="bottom-nav-log" onClick={() => setLogOpen(true)}>
              <span className="bottom-nav-icon" aria-hidden="true">
                <Plus size="1em" aria-hidden="true" strokeWidth={2.75} />
              </span>
              Log
            </button>
            <NavLink to="/library">
              <span className="bottom-nav-icon" aria-hidden="true">
                <Library size="1em" aria-hidden="true" />
              </span>
              Library
            </NavLink>
            <NavLink to="/feed">
              <span className="bottom-nav-icon" aria-hidden="true">
                <Users size="1em" aria-hidden="true" />
              </span>
              Feed
            </NavLink>
            <NavCord tabs={tabs} />
          </>
        ) : (
          <NavLink to="/login">
            <span className="bottom-nav-icon" aria-hidden="true">
              <CircleUser size="1em" aria-hidden="true" />
            </span>
            Log in
          </NavLink>
        )}
      </nav>
      {logOpen && <QuickLog onClose={() => setLogOpen(false)} />}
    </>
  );
};

export default BottomNav;
